module.exports = __webpack_public_path__ + "img/DE01673.83251567.png";